module.exports = __webpack_public_path__ + "static/media/icon-close.56aba6b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-close.svg
// module id = 1248
// module chunks = 19